import { render, staticRenderFns } from "./HolderCombo.vue?vue&type=template&id=5753a664"
import script from "./HolderCombo.vue?vue&type=script&lang=js"
export * from "./HolderCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports